import React from 'react';
import HostIcon from '@asset/image/user/icon_host.svg';
import CoHostIcon from '@asset/image/user/icon_co_host.svg';
import ScreenIcon1x from '@asset/image/user/member_sharing(1).png';
import ScreenIcon2x from '@asset/image/user/member_sharing(1)@2x.png';
import MicState from '@component/mic-state';
import PhoneState from '@component/phone-state';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import LecturerRight from './LecturerRight';
import { LecturerModeProps } from './LecturerMode.type';
import './LecturerMode.scss';
import { getBigVideoData } from '@store/studio/studio.slice';
import { BOOL, RemoteStream, UserInfoItem, WeMeetClient, UserItem } from '@tencent/wemeet-websdk-next';
import { VideoPrefix } from '@constant/media';
import VideoPlay from '@component/video-play/VideoPlay';
import { useTranslation } from 'react-i18next';
import { hasScreen, isUserVideoOn } from '@utils/helper/media';
import { changeIfShowSmallList, getIfShowSmallList } from '@store/ui/ui.slice';
import { isMobileBrowser } from '@utils/browser';

const isPhone = isMobileBrowser();

const LecturerMode: React.FC<LecturerModeProps> = () => {
  const bigVideoData = useAppSelector(getBigVideoData);
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const showSmallList = useAppSelector(getIfShowSmallList);
  const onArrowClick = () => {
    dispatch(changeIfShowSmallList(!showSmallList));
  };
  return (
    <div className={`lecturer-mode ${isPhone ? 'lecturer-mode-phone' : ''}`}>
      <div className={`lecturer-mode__left ${isPhone ? 'lecturer-mode-phone__left' : ''}`}>
        {!isPhone ? (
          <div className="lecturer-mode__left__trigger">
            <i
              onClick={onArrowClick}
              className={`lecturer-mode__left__trigger__i lecturer-mode__left__trigger__i--${
                showSmallList ? 'fold' : 'unfold'
              }`}
            />
          </div>
        ) : null}
        {/* TODO 你本人正在共享屏幕图片 */}
        {/* 视频 */}
        <VideoPlay
          stream={bigVideoData?.rtcStream?.stream as RemoteStream}
          className={bigVideoData?.isSelf ? 'self-video' : ''}
          isLocal={!!bigVideoData?.rtcStream?.isLocal}
          prefix={VideoPrefix.big}
          streamType={bigVideoData?.rtcStream?.streamType}
          isSwitchBig={bigVideoData?.rtcStream?.isLocal === false}
          videoId={bigVideoData?.rtcStream?.videoId ?? ''}
          userId={bigVideoData?.id as UserItem}
          cameraOn={isUserVideoOn(bigVideoData as UserInfoItem)}
        />
        <div className="lecturer-mode__left__user">
          {WeMeetClient.utils.isHost(bigVideoData as UserInfoItem) && (
            <img src={HostIcon} alt="" className="icon-host" />
          )}
          {WeMeetClient.utils.isCoHost(bigVideoData as UserInfoItem) && (
            <img src={CoHostIcon} alt="" className="icon-co-host" />
          )}
          {hasScreen(bigVideoData as UserInfoItem) && !bigVideoData?.isPhoneUser && (
            <img srcSet={`${ScreenIcon1x}  1x,${ScreenIcon2x} 2x`} alt="" />
          )}
          {!bigVideoData?.isPhoneUser && !hasScreen(bigVideoData as UserInfoItem) && (
            <MicState
              mode="small"
              micOn={bigVideoData?.up_audio_on?.__value === BOOL.true}
              stream={bigVideoData?.rtcStream?.stream}
            />
          )}
          {bigVideoData?.isPhoneUser && !hasScreen(bigVideoData as UserInfoItem) && (
            <PhoneState
              mode="small"
              on={bigVideoData?.up_audio_on?.__value === BOOL.true}
              stream={bigVideoData?.rtcStream?.stream}
            />
          )}
          <span className="lecturer-mode__left__user__nickname">
            {bigVideoData?.nickname}
            {hasScreen(bigVideoData as UserInfoItem) ? t('的屏幕') : ''}
          </span>
        </div>
      </div>
      {showSmallList ? <LecturerRight /> : null}
    </div>
  );
};

export default React.memo(LecturerMode);
